<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('activeTarget.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="box">
                <div class="box-item">
                    {{ $t('activeTarget.step') }}
                    <div class="right" @click="openTargetBox(0)">
                        {{ activeTarget.userTargetStep }}
                        {{ $t('activeTarget.stepUnit') }}
                        <img class="to-img" :src="require(`@/assets/theme/${theme}/status/01dailyActive/06to.svg`)">
                    </div>
                </div>
                <div class="box-item">
                    {{ $t('activeTarget.cal') }}
                    <div class="right" @click="openTargetBox(1)">
                        {{ activeTarget.userTargetCalorie }}
                        {{ $t('activeTarget.calUnit') }}
                        <img class="to-img" :src="require(`@/assets/theme/${theme}/status/01dailyActive/06to.svg`)">
                    </div>
                </div>
                <div class="box-item">
                    {{ $t('activeTarget.strength') }}
                    <div class="right" @click="openTargetBox(2)">
                        {{ activeTarget.userTargetSportStrength / 60 }}
                        {{ $t('activeTarget.strengthUnit') }}
                        <img class="to-img" :src="require(`@/assets/theme/${theme}/status/01dailyActive/06to.svg`)">
                    </div>
                </div>
            </div>
            <van-popup v-model="showTarget" round position="bottom">
                <van-picker
                    :title="$t('dailyActive.stepTargetTitle')"
                    show-toolbar
                    :columns="columns"
                    :default-index="stepTargetIndex"
                    @cancel="showTarget = false"
                    @confirm="onConfirm"
                />
            </van-popup>
            <van-popup v-model="showCalTarget" round position="bottom">
                <van-picker
                    :title="$t('dailyActive.calTargetTitle')"
                    show-toolbar
                    :columns="calColumns"
                    :default-index="calTargetIndex"
                    @cancel="showCalTarget = false"
                    @confirm="onConfirm"
                />
            </van-popup>
            <van-popup v-model="showStrengthTarget" round position="bottom">
                <van-picker
                    :title="$t('activeTarget.strength')"
                    show-toolbar
                    :columns="strengthColumns"
                    :default-index="strengthTargetIndex"
                    @cancel="showStrengthTarget = false"
                    @confirm="onConfirm"
                />
            </van-popup>
        </div>
    </div>
</template>

<script>
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: '21activeTarget',
    data() {
        return {
            theme: 'light',
            activeType: 0,
            activeTarget: {},
            showTarget: false,
            columns: [
                1000,
                1100,
                1200,
                1300,
                1400,
                1500,
                1600,
                1700,
                1800,
                1900,
                2000,
                2100,
                2200,
                2300,
                2400,
                2500,
                2600,
                2700,
                2800,
                2900,
                3000,
                3100,
                3200,
                3300,
                3400,
                3500,
                3600,
                3700,
                3800,
                3900,
                4000,
                4100,
                4200,
                4300,
                4400,
                4500,
                4600,
                4700,
                4800,
                4900,
                5000,
                5100,
                5200,
                5300,
                5400,
                5500,
                5600,
                5700,
                5800,
                5900,
                6000,
                6100,
                6200,
                6300,
                6400,
                6500,
                6600,
                6700,
                6800,
                6900,
                7000,
                7100,
                7200,
                7300,
                7400,
                7500,
                7600,
                7700,
                7800,
                7900,
                8000,
                8100,
                8200,
                8300,
                8400,
                8500,
                8600,
                8700,
                8800,
                8900,
                9000,
                9100,
                9200,
                9300,
                9400,
                9500,
                9600,
                9700,
                9800,
                9900,
                10000,
                10100,
                10200,
                10300,
                10400,
                10500,
                10600,
                10700,
                10800,
                10900,
                11000,
                11100,
                11200,
                11300,
                11400,
                11500,
                11600,
                11700,
                11800,
                11900,
                12000,
                12100,
                12200,
                12300,
                12400,
                12500,
                12600,
                12700,
                12800,
                12900,
                13000,
                13100,
                13200,
                13300,
                13400,
                13500,
                13600,
                13700,
                13800,
                13900,
                14000,
                14100,
                14200,
                14300,
                14400,
                14500,
                14600,
                14700,
                14800,
                14900,
                15000,
                15100,
                15200,
                15300,
                15400,
                15500,
                15600,
                15700,
                15800,
                15900,
                16000,
                16100,
                16200,
                16300,
                16400,
                16500,
                16600,
                16700,
                16800,
                16900,
                17000,
                17100,
                17200,
                17300,
                17400,
                17500,
                17600,
                17700,
                17800,
                17900,
                18000,
                18100,
                18200,
                18300,
                18400,
                18500,
                18600,
                18700,
                18800,
                18900,
                19000,
                19100,
                19200,
                19300,
                19400,
                19500,
                19600,
                19700,
                19800,
                19900,
                20000,
                20100,
                20200,
                20300,
                20400,
                20500,
                20600,
                20700,
                20800,
                20900,
                21000,
                21100,
                21200,
                21300,
                21400,
                21500,
                21600,
                21700,
                21800,
                21900,
                22000,
                22100,
                22200,
                22300,
                22400,
                22500,
                22600,
                22700,
                22800,
                22900,
                23000,
                23100,
                23200,
                23300,
                23400,
                23500,
                23600,
                23700,
                23800,
                23900,
                24000,
                24100,
                24200,
                24300,
                24400,
                24500,
                24600,
                24700,
                24800,
                24900,
                25000,
                25100,
                25200,
                25300,
                25400,
                25500,
                25600,
                25700,
                25800,
                25900,
                26000,
                26100,
                26200,
                26300,
                26400,
                26500,
                26600,
                26700,
                26800,
                26900,
                27000,
                27100,
                27200,
                27300,
                27400,
                27500,
                27600,
                27700,
                27800,
                27900,
                28000,
                28100,
                28200,
                28300,
                28400,
                28500,
                28600,
                28700,
                28800,
                28900,
                29000,
                29100,
                29200,
                29300,
                29400,
                29500,
                29600,
                29700,
                29800,
                29900,
                30000,
                30100,
                30200,
                30300,
                30400,
                30500,
                30600,
                30700,
                30800,
                30900,
                31000,
                31100,
                31200,
                31300,
                31400,
                31500,
                31600,
                31700,
                31800,
                31900,
                32000,
                32100,
                32200,
                32300,
                32400,
                32500,
                32600,
                32700,
                32800,
                32900,
                33000,
                33100,
                33200,
                33300,
                33400,
                33500,
                33600,
                33700,
                33800,
                33900,
                34000,
                34100,
                34200,
                34300,
                34400,
                34500,
                34600,
                34700,
                34800,
                34900,
                35000,
                35100,
                35200,
                35300,
                35400,
                35500,
                35600,
                35700,
                35800,
                35900,
                36000,
                36100,
                36200,
                36300,
                36400,
                36500,
                36600,
                36700,
                36800,
                36900,
                37000,
                37100,
                37200,
                37300,
                37400,
                37500,
                37600,
                37700,
                37800,
                37900,
                38000,
                38100,
                38200,
                38300,
                38400,
                38500,
                38600,
                38700,
                38800,
                38900,
                39000,
                39100,
                39200,
                39300,
                39400,
                39500,
                39600,
                39700,
                39800,
                39900,
                40000,
                40100,
                40200,
                40300,
                40400,
                40500,
                40600,
                40700,
                40800,
                40900,
                41000,
                41100,
                41200,
                41300,
                41400,
                41500,
                41600,
                41700,
                41800,
                41900,
                42000,
                42100,
                42200,
                42300,
                42400,
                42500,
                42600,
                42700,
                42800,
                42900,
                43000,
                43100,
                43200,
                43300,
                43400,
                43500,
                43600,
                43700,
                43800,
                43900,
                44000,
                44100,
                44200,
                44300,
                44400,
                44500,
                44600,
                44700,
                44800,
                44900,
                45000,
                45100,
                45200,
                45300,
                45400,
                45500,
                45600,
                45700,
                45800,
                45900,
                46000,
                46100,
                46200,
                46300,
                46400,
                46500,
                46600,
                46700,
                46800,
                46900,
                47000,
                47100,
                47200,
                47300,
                47400,
                47500,
                47600,
                47700,
                47800,
                47900,
                48000,
                48100,
                48200,
                48300,
                48400,
                48500,
                48600,
                48700,
                48800,
                48900,
                49000,
                49100,
                49200,
                49300,
                49400,
                49500,
                49600,
                49700,
                49800,
                49900,
                50000
            ],
            stepTargetIndex: 0,
            showCalTarget: false,
            calColumns: [
                100,
                200,
                300,
                400,
                500,
                600,
                700,
                800,
                900,
                1000,
                1100,
                1200,
                1300,
                1400,
                1500,
                1600,
                1700,
                1800,
                1900,
                2000,
                2100,
                2200,
                2300,
                2400,
                2500,
                2600,
                2700,
                2800,
                2900,
                3000,
                3100,
                3200,
                3300,
                3400,
                3500,
                3600,
                3700,
                3800,
                3900,
                4000,
                4100,
                4200,
                4300,
                4400,
                4500,
                4600,
                4700,
                4800,
                4900,
                5000
            ],
            calTargetIndex: 0,
            strengthColumns: [
                5,
                10,
                15,
                20,
                25,
                30,
                35,
                40,
                45,
                50,
                55,
                60,
                65,
                70,
                75,
                80,
                85,
                90,
                95,
                100,
                105,
                110,
                115,
                120,
                125,
                130,
                135,
                140,
                145,
                150,
                155,
                160,
                165,
                170,
                175,
                180,
                185,
                190,
                195,
                200,
                205,
                210,
                215,
                220,
                225,
                230,
                235,
                240,
                245,
                250,
                255,
                260,
                265,
                270,
                275,
                280,
                285,
                290,
                295,
                300,
                305,
                310,
                315,
                320,
                325,
                330,
                335,
                340,
                345,
                350,
                355,
                360,
                365,
                370,
                375,
                380,
                385,
                390,
                395,
                400,
                405,
                410,
                415,
                420,
                425,
                430,
                435,
                440,
                445,
                450,
                455,
                460,
                465,
                470,
                475,
                480,
                485,
                490,
                495,
                500,
                505,
                510,
                515,
                520,
                525,
                530,
                535,
                540,
                545,
                550,
                555,
                560,
                565,
                570,
                575,
                580,
                585,
                590,
                595,
                600,
                605,
                610,
                615,
                620,
                625,
                630,
                635,
                640,
                645,
                650,
                655,
                660,
                665,
                670,
                675,
                680,
                685,
                690,
                695,
                700,
                705,
                710,
                715,
                720,
                725,
                730,
                735,
                740,
                745,
                750,
                755,
                760,
                765,
                770,
                775,
                780,
                785,
                790,
                795,
                800,
                805,
                810,
                815,
                820,
                825,
                830,
                835,
                840,
                845,
                850,
                855,
                860,
                865,
                870,
                875,
                880,
                885,
                890,
                895,
                900
            ],
            showStrengthTarget: false,
            strengthTargetIndex: 0
        }
    },
    mounted() {
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme
        }
        this.getActiveTarget();
    },
    methods: {
        back() {
            this.$router.back()
        },
        getActiveTarget() {
            this.$api.status.activeTarget().then(res => {
                this.activeTarget = res.info
            })
        },
        openTargetBox(activeType) {
            this.activeType = activeType
            if (activeType == 0) {
                this.stepTargetIndex = (this.activeTarget.userTargetStep - 1000) / 100
                this.showTarget = true
            } else if (activeType == 1) {
                this.calTargetIndex = (this.activeTarget.userTargetCalorie) / 100 - 1
                this.showCalTarget = true
            } else {
                this.strengthTargetIndex = (this.activeTarget.userTargetSportStrength) / 60 / 5 - 1
                this.showStrengthTarget = true
            }
        },
        onConfirm(value, index) {
            if (this.activeType == 0) {
                this.$api.status.updateTarget({
                    userTargetStep: value
                }).then(res => {
                    this.activeTarget.userTargetStep = value
                    WebJSBridge.call("updateActiveTarget", this.activeTarget, function (res) {
                    });
                })
                this.showTarget = false
            } else if (this.activeType == 1) {
                this.$api.status.updateTarget({
                    userTargetCalorie: value
                }).then(res => {
                    this.activeTarget.userTargetCalorie = value
                    WebJSBridge.call("updateActiveTarget", this.activeTarget, function (res) {
                    });
                })
                this.showCalTarget = false
            } else if (this.activeType == 2) {
                this.$api.status.updateTarget({
                    userTargetSportStrength: value * 60
                }).then(res => {
                    this.activeTarget.userTargetSportStrength = value * 60
                    WebJSBridge.call("updateActiveTarget", this.activeTarget, function (res) {
                    });
                })
                this.showStrengthTarget = false
            }
        },
    }
}
</script>

<style scoped>
.box {
    width: 345px;
    height: 135px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 11px auto;
}

.box-item {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    color: var(--text-color-1);
    width: 315px;
    margin: 0 auto;
    padding-top: 22px;
}

.right {
    color: var(--text-color-2);
    display: flex;
    align-items: center;
}

.to-img {
    width: 16px;
}


/deep/ .van-picker {
    background-color: var(--bg-color-2);
    color: var(--text-color-1);
}

/deep/ .van-picker__mask {
    background-image: none;
}

/deep/ .van-picker-column__item {
    color: var(--text-color-1);
    font-size: 10px;
}

/deep/ .van-picker__confirm {
    color: #22ACFB;
    font-size: 17px;
}

/deep/ .van-picker__cancel {
    font-size: 17px;
    color: var(--text-color-2);
}

/deep/ .van-picker__title {
    font-size: 17px;
}

/deep/ .van-picker-column__item {
    font-size: 16px;
}

/deep/ .van-picker-column__item--selected {
    font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/status/21activeTarget.vue